<div class="ds-legend" [ngClass]="type">
  <div class="dot" [ngClass]="color" style="--custom-color: {{customColor}}"></div>
  <ng-content></ng-content>
</div>
